/** The one action we may resume after the full-page sign-in round trip. */
export const PENDING_LIBRARY_ADD_KEY = "ato.pending-library-add.v1";
const MAX_AGE_MS = 10 * 60_000;

export function rememberPendingLibraryAdd(listingId: string): void {
  try {
    sessionStorage.setItem(
      PENDING_LIBRARY_ADD_KEY,
      JSON.stringify({ listingId, at: Date.now() }),
    );
  } catch {
    // Sign-in still works; only the automatic follow-up is unavailable.
  }
}

export function consumePendingLibraryAdd(listingId: string): boolean {
  try {
    const raw = sessionStorage.getItem(PENDING_LIBRARY_ADD_KEY);
    if (!raw) return false;
    const value = JSON.parse(raw) as { listingId?: unknown; at?: unknown };
    if (
      value.listingId !== listingId ||
      typeof value.at !== "number" ||
      Date.now() - value.at > MAX_AGE_MS
    ) {
      sessionStorage.removeItem(PENDING_LIBRARY_ADD_KEY);
      return false;
    }
    sessionStorage.removeItem(PENDING_LIBRARY_ADD_KEY);
    return true;
  } catch {
    return false;
  }
}

export function clearPendingLibraryAdd(): void {
  try {
    sessionStorage.removeItem(PENDING_LIBRARY_ADD_KEY);
  } catch {
    // Nothing to clear.
  }
}
